export function SegmentedButton({
  isSelected,
  onClick,
  children,
}: {
  isSelected: boolean;
  onClick: () => void;
  children: string;
}) {
  return (
    <button
      type="button"
      aria-pressed={isSelected}
      // Keeps focus in the input being edited: without this the blur lands
      // first, its validation error re-renders the field, and the click never
      // completes on the button it started on.
      onMouseDown={(event) => event.preventDefault()}
      onClick={onClick}
      className={
        isSelected
          ? "flex-1 rounded-md bg-white px-3 py-1.5 text-sm font-medium text-gray-900 shadow-sm"
          : "flex-1 rounded-md px-3 py-1.5 text-sm font-medium text-gray-500 transition-colors hover:text-gray-700"
      }
    >
      {children}
    </button>
  );
}
